import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { CallMetadata } from "./call.model";

@Injectable({
  providedIn: 'root'
})
export class CallUtilsService {

  constructor(
    private http: HttpClient
  ){}

  public getCallMetadata(callId: string): Observable<CallMetadata> {
    return this.http.get<CallMetadata>(`${AppConfig.endpointURL}/v1/calls/${callId}/metadata`);
  }
}